import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import "./AdsCreativeHotelList.scss";

const AdsCreativeHotelList = ({
  hotels = [],
  activeHotelId,
  onSelectHotel,
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  doneCount,
  totalCount,
}) => {
  return (
    <div className="ads-creative-hotel-list">
      <div className="hotel-list-search">
        <TextField
          size="small"
          placeholder="Search hotels..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ fontSize: 16, color: "#bab7b7" }} />
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      </div>

      <div className="hotel-list-filters">
        <button
          className={`filter-btn ${statusFilter === "all" ? "active" : ""}`}
          onClick={() => setStatusFilter("all")}
        >
          All
        </button>
        <button
          className={`filter-btn ${statusFilter === "done" ? "active" : ""}`}
          onClick={() => setStatusFilter("done")}
        >
          Done
        </button>
        <button
          className={`filter-btn ${statusFilter === "in_progress" ? "active" : ""}`}
          onClick={() => setStatusFilter("in_progress")}
        >
          In progress
        </button>
      </div>

      <div className="hotel-list-count">
        {doneCount} / {totalCount} done
      </div>

      <div className="hotel-list-items">
        {hotels.map((hotel) => (
          <div
            key={hotel.hotel_id}
            className={`hotel-list-item ${activeHotelId === hotel.hotel_id ? "active" : ""}`}
            onClick={() => onSelectHotel(hotel.hotel_id)}
          >
            <div className="hotel-item-info">
              <span className="hotel-item-name">{hotel.hotel_name}</span>
              {hotel.location && <span className="hotel-item-location">{hotel.location}</span>}
            </div>
            <span className={`hotel-item-status-dot status-${hotel.status}`} />
          </div>
        ))}
      </div>

    </div>
  );
};

export default AdsCreativeHotelList;
